import { AppSettings } from "@/AppSettings";
import { SourceDataFormStatus } from "@/api/dtos";

const sourceDataFormStatusToIcon = (status?: SourceDataFormStatus) => {
    switch (status) {
        case SourceDataFormStatus.Complete:
            return AppSettings.icons.statusComplete;
        case SourceDataFormStatus.Started:
            return AppSettings.icons.statusStarted;
        case SourceDataFormStatus.None:
        default:
            return AppSettings.icons.statusNone;
    }
}

export default sourceDataFormStatusToIcon;